import { makeEroadStyles } from "../../../styles";

const useStyles = makeEroadStyles(
  () => ({
    root: {
      position: "absolute",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      right: 0,
      bottom: 0,
      left: 0,
      top: 0,
    },
  }),
  { name: "PageSpinner" }
);

export { useStyles };
